import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=245b2fd6&scoped=true&"
import script from "./Accepted.vue?vue&type=script&lang=js&"
export * from "./Accepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b2fd6",
  null
  
)

export default component.exports